import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPimcoreComponent } from './simple-icons-pimcore.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPimcoreComponent ],
    exports:      [ SimpleIconsPimcoreComponent ],
    bootstrap:    []
})
export class SimpleIconsPimcoreModule {}
